import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/mixins/chartjs';
import 'src/mixins/prismjs';
import { enableES5 } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  SettingsProvider,
  i18nSetup,
  restoreSettings
} from '@nsd/fe';
import { configureStore } from 'src/store';
import App from 'src/App';
import { initAppInsights } from 'src/utils/appInsights';
import './index.css';
import { initClarity } from './utils/clarity';

// Same name from App.js; for making an educated
// guess on the alert and notification path
// (also can pass in manual path in App.js)
const APP_INTERNAL_NAME = 'Admin-Qore';

enableES5();
initAppInsights();
initClarity();

const store = configureStore();
const settings = restoreSettings();

const root = createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <Provider store={store}>
      <SettingsProvider settings={settings}>
        <App />
      </SettingsProvider>
    </Provider>
  );
};

Promise.resolve(i18nSetup())
  .catch(() => null)
  .finally(renderApp);
